import { Suspense } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import WorksheetHero from './components/WorksheetHero';
import RegrasOuro from './components/RegrasOuro';
import CriadorEncantations from './components/CriadorEncantations';
import CompromissoPratica from './components/CompromissoPratica';
import CTAWorksheet from './components/CTAWorksheet';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const worksheetEncantationsSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'Worksheet Encantations — Guia Prático Tony Robbins',
    description: 'Guia completo para criar e praticar Encantations poderosas com movimento e emoção, baseado na técnica de Tony Robbins.',
    image: `${SITE_URL}/og-worksheet-encantations.png`,
    totalTime: 'PT30M',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'Entenda as Regras de Ouro',
        text: 'Aprenda os 5 princípios fundamentais das Encantations: presente, emoção genuína, movimento corporal, repetição diária e crença absoluta.'
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: 'Crie Suas Encantations',
        text: 'Escreva suas afirmações poderosas no presente, com emoção e especificidade. Use linguagem positiva e energizante.'
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: 'Adicione Movimento',
        text: 'Combine cada Encantation com movimentos corporais expansivos e energéticos que amplificam a emoção.'
      },
      {
        '@type': 'HowToStep',
        position: 4,
        name: 'Pratique Diariamente',
        text: 'Estabeleça um compromisso de prática diária, preferencialmente pela manhã, para reprogramar seu sistema nervoso.'
      }
    ]
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Worksheet Encantations | Guia Prático — Carta do Eu Futuro',
    url: `${SITE_URL}/worksheet-encantations`,
    description: 'Worksheet completo de Encantations para criar e praticar suas afirmações poderosas com movimento e emoção. Guia prático baseado na técnica de Tony Robbins.',
    inLanguage: 'pt-BR',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Worksheet Encantations', item: `${SITE_URL}/worksheet-encantations` },
      ],
    },
  }
];

export default function WorksheetEncantationsPage() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <SEOHead
        title="Worksheet Encantations | Guia Prático Tony Robbins — Carta do Eu Futuro"
        description="Worksheet completo de Encantations para criar e praticar suas afirmações poderosas com movimento e emoção. Guia prático baseado na técnica de Tony Robbins."
        keywords="worksheet encantations, tony robbins, afirmações poderosas, PNL, desenvolvimento pessoal"
        canonical="/worksheet-encantations"
        schema={worksheetEncantationsSchema}
      />
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#D4AF37]"></div>
          </div>
        }
      >
        <WorksheetHero />
        <RegrasOuro />
        <CriadorEncantations />
        <CompromissoPratica />
        <CTAWorksheet />
      </Suspense>
    </div>
  );
}